import { render, staticRenderFns } from "./ScorecardBreakdown.vue?vue&type=template&id=77867cc5&scoped=true"
import script from "./ScorecardBreakdown.vue?vue&type=script&lang=js"
export * from "./ScorecardBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ScorecardBreakdown.vue?vue&type=style&index=0&id=77867cc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77867cc5",
  null
  
)

export default component.exports